<!-- inline style Radio -->
<div class="m-form__group form-group row">
  <label [for]="formElement.name" [ngClass]="labelClass">{{formElement.label}}
    <span class="mandatoryColor" *ngIf="(label || formElement.label) && (required ||formElement.required || formElement.showAstrisk)">*</span>
  </label>
  <div [ngClass]="inputDiv">
    <div [ngClass]="inputClass">
      <label [ngClass]="inputLabelDiv" *ngFor="let option of formElement.options">
        <input type="radio"  [disabled]="isDisabled()" [(checked)]="value === option.value"   [name]="formElement.name"   value="option.value" (blur)="onBlur()" (change)="onChange(option.value)"> {{option.name}}
        <span></span>
      </label>
    </div>
  </div>
  <label [for]="formElement.name" [ngClass]="labelClass">
  </label>
  <div [ngClass]="inputDiv">
			<ng-content></ng-content>
  </div>
